import { render, staticRenderFns } from "./ShowKacem.vue?vue&type=template&id=590ddc63&"
import script from "./ShowKacem.vue?vue&type=script&lang=js&"
export * from "./ShowKacem.vue?vue&type=script&lang=js&"
import style0 from "./ShowKacem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports